import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';

import ScrollToTop from './Hoc/ScrollToTop';
import Routes from './lib/routes/Routes';
import { initMetaPixelWithUserInfo } from './lib/utils/metaPixel';
import { getInfo } from './lib/api/api';

const Root = () => {
  useEffect(() => {
    // Meta 픽셀 스크립트가 로드될 때까지 대기 후 초기화
    const initPixel = () => {
      // 픽셀 스크립트가 로드되었는지 확인
      if (typeof window !== 'undefined' && window.fbq) {
        // 로그인 상태 확인
        const isLoggedIn = sessionStorage.logged === 'true' && sessionStorage.accessToken;
        
        if (isLoggedIn) {
          // 로그인된 경우 사용자 정보로 초기화
          initMetaPixelWithUserInfo(getInfo);
        } else {
          // 로그인되지 않은 경우 기본 초기화
          initMetaPixelWithUserInfo(null);
        }
      } else {
        // 픽셀 스크립트가 아직 로드되지 않은 경우 잠시 후 재시도
        setTimeout(initPixel, 100);
      }
    };

    // DOM이 로드된 후 초기화 시도
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initPixel);
    } else {
      initPixel();
    }
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes />
    </BrowserRouter>
  );
};

export default Root;
